/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TabletLayoutRouteImport } from './routes/_tablet-layout'
import { Route as TabletLayoutIndexRouteImport } from './routes/_tablet-layout/index'
import { Route as TabletLayoutBranchIdRouteImport } from './routes/_tablet-layout/branch/$id'
import { Route as TabletLayoutBranchIdIndexRouteImport } from './routes/_tablet-layout/branch/$id/index'
import { Route as TabletLayoutBranchIdCreateWizardRouteImport } from './routes/_tablet-layout/branch/$id/create/_wizard'
import { Route as TabletLayoutBranchIdCreateWizardSuccessRouteImport } from './routes/_tablet-layout/branch/$id/create/_wizard/success'
import { Route as TabletLayoutBranchIdCreateWizardSubmitRouteImport } from './routes/_tablet-layout/branch/$id/create/_wizard/submit'
import { Route as TabletLayoutBranchIdCreateWizardServiceRouteImport } from './routes/_tablet-layout/branch/$id/create/_wizard/service'
import { Route as TabletLayoutBranchIdCreateWizardModeRouteImport } from './routes/_tablet-layout/branch/$id/create/_wizard/mode'
import { Route as TabletLayoutBranchIdCreateWizardMasterIndexRouteImport } from './routes/_tablet-layout/branch/$id/create/_wizard/master.index'
import { Route as TabletLayoutBranchIdCreateWizardMasterPairRouteImport } from './routes/_tablet-layout/branch/$id/create/_wizard/master.pair'

const TabletLayoutRoute = TabletLayoutRouteImport.update({
  id: '/_tablet-layout',
  getParentRoute: () => rootRouteImport,
} as any)
const TabletLayoutIndexRoute = TabletLayoutIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => TabletLayoutRoute,
} as any)
const TabletLayoutBranchIdRoute = TabletLayoutBranchIdRouteImport.update({
  id: '/branch/$id',
  path: '/branch/$id',
  getParentRoute: () => TabletLayoutRoute,
} as any)
const TabletLayoutBranchIdIndexRoute =
  TabletLayoutBranchIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => TabletLayoutBranchIdRoute,
  } as any)
const TabletLayoutBranchIdCreateWizardRoute =
  TabletLayoutBranchIdCreateWizardRouteImport.update({
    id: '/create/_wizard',
    path: '/create',
    getParentRoute: () => TabletLayoutBranchIdRoute,
  } as any)
const TabletLayoutBranchIdCreateWizardSuccessRoute =
  TabletLayoutBranchIdCreateWizardSuccessRouteImport.update({
    id: '/success',
    path: '/success',
    getParentRoute: () => TabletLayoutBranchIdCreateWizardRoute,
  } as any)
const TabletLayoutBranchIdCreateWizardSubmitRoute =
  TabletLayoutBranchIdCreateWizardSubmitRouteImport.update({
    id: '/submit',
    path: '/submit',
    getParentRoute: () => TabletLayoutBranchIdCreateWizardRoute,
  } as any)
const TabletLayoutBranchIdCreateWizardServiceRoute =
  TabletLayoutBranchIdCreateWizardServiceRouteImport.update({
    id: '/service',
    path: '/service',
    getParentRoute: () => TabletLayoutBranchIdCreateWizardRoute,
  } as any)
const TabletLayoutBranchIdCreateWizardModeRoute =
  TabletLayoutBranchIdCreateWizardModeRouteImport.update({
    id: '/mode',
    path: '/mode',
    getParentRoute: () => TabletLayoutBranchIdCreateWizardRoute,
  } as any)
const TabletLayoutBranchIdCreateWizardMasterIndexRoute =
  TabletLayoutBranchIdCreateWizardMasterIndexRouteImport.update({
    id: '/master/',
    path: '/master/',
    getParentRoute: () => TabletLayoutBranchIdCreateWizardRoute,
  } as any)
const TabletLayoutBranchIdCreateWizardMasterPairRoute =
  TabletLayoutBranchIdCreateWizardMasterPairRouteImport.update({
    id: '/master/pair',
    path: '/master/pair',
    getParentRoute: () => TabletLayoutBranchIdCreateWizardRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof TabletLayoutIndexRoute
  '/branch/$id': typeof TabletLayoutBranchIdRouteWithChildren
  '/branch/$id/': typeof TabletLayoutBranchIdIndexRoute
  '/branch/$id/create': typeof TabletLayoutBranchIdCreateWizardRouteWithChildren
  '/branch/$id/create/mode': typeof TabletLayoutBranchIdCreateWizardModeRoute
  '/branch/$id/create/service': typeof TabletLayoutBranchIdCreateWizardServiceRoute
  '/branch/$id/create/submit': typeof TabletLayoutBranchIdCreateWizardSubmitRoute
  '/branch/$id/create/success': typeof TabletLayoutBranchIdCreateWizardSuccessRoute
  '/branch/$id/create/master/pair': typeof TabletLayoutBranchIdCreateWizardMasterPairRoute
  '/branch/$id/create/master/': typeof TabletLayoutBranchIdCreateWizardMasterIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof TabletLayoutIndexRoute
  '/branch/$id': typeof TabletLayoutBranchIdIndexRoute
  '/branch/$id/create': typeof TabletLayoutBranchIdCreateWizardRouteWithChildren
  '/branch/$id/create/mode': typeof TabletLayoutBranchIdCreateWizardModeRoute
  '/branch/$id/create/service': typeof TabletLayoutBranchIdCreateWizardServiceRoute
  '/branch/$id/create/submit': typeof TabletLayoutBranchIdCreateWizardSubmitRoute
  '/branch/$id/create/success': typeof TabletLayoutBranchIdCreateWizardSuccessRoute
  '/branch/$id/create/master/pair': typeof TabletLayoutBranchIdCreateWizardMasterPairRoute
  '/branch/$id/create/master': typeof TabletLayoutBranchIdCreateWizardMasterIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_tablet-layout': typeof TabletLayoutRouteWithChildren
  '/_tablet-layout/': typeof TabletLayoutIndexRoute
  '/_tablet-layout/branch/$id': typeof TabletLayoutBranchIdRouteWithChildren
  '/_tablet-layout/branch/$id/': typeof TabletLayoutBranchIdIndexRoute
  '/_tablet-layout/branch/$id/create/_wizard': typeof TabletLayoutBranchIdCreateWizardRouteWithChildren
  '/_tablet-layout/branch/$id/create/_wizard/mode': typeof TabletLayoutBranchIdCreateWizardModeRoute
  '/_tablet-layout/branch/$id/create/_wizard/service': typeof TabletLayoutBranchIdCreateWizardServiceRoute
  '/_tablet-layout/branch/$id/create/_wizard/submit': typeof TabletLayoutBranchIdCreateWizardSubmitRoute
  '/_tablet-layout/branch/$id/create/_wizard/success': typeof TabletLayoutBranchIdCreateWizardSuccessRoute
  '/_tablet-layout/branch/$id/create/_wizard/master/pair': typeof TabletLayoutBranchIdCreateWizardMasterPairRoute
  '/_tablet-layout/branch/$id/create/_wizard/master/': typeof TabletLayoutBranchIdCreateWizardMasterIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/branch/$id'
    | '/branch/$id/'
    | '/branch/$id/create'
    | '/branch/$id/create/mode'
    | '/branch/$id/create/service'
    | '/branch/$id/create/submit'
    | '/branch/$id/create/success'
    | '/branch/$id/create/master/pair'
    | '/branch/$id/create/master/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/branch/$id'
    | '/branch/$id/create'
    | '/branch/$id/create/mode'
    | '/branch/$id/create/service'
    | '/branch/$id/create/submit'
    | '/branch/$id/create/success'
    | '/branch/$id/create/master/pair'
    | '/branch/$id/create/master'
  id:
    | '__root__'
    | '/_tablet-layout'
    | '/_tablet-layout/'
    | '/_tablet-layout/branch/$id'
    | '/_tablet-layout/branch/$id/'
    | '/_tablet-layout/branch/$id/create/_wizard'
    | '/_tablet-layout/branch/$id/create/_wizard/mode'
    | '/_tablet-layout/branch/$id/create/_wizard/service'
    | '/_tablet-layout/branch/$id/create/_wizard/submit'
    | '/_tablet-layout/branch/$id/create/_wizard/success'
    | '/_tablet-layout/branch/$id/create/_wizard/master/pair'
    | '/_tablet-layout/branch/$id/create/_wizard/master/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  TabletLayoutRoute: typeof TabletLayoutRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_tablet-layout': {
      id: '/_tablet-layout'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof TabletLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_tablet-layout/': {
      id: '/_tablet-layout/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof TabletLayoutIndexRouteImport
      parentRoute: typeof TabletLayoutRoute
    }
    '/_tablet-layout/branch/$id': {
      id: '/_tablet-layout/branch/$id'
      path: '/branch/$id'
      fullPath: '/branch/$id'
      preLoaderRoute: typeof TabletLayoutBranchIdRouteImport
      parentRoute: typeof TabletLayoutRoute
    }
    '/_tablet-layout/branch/$id/': {
      id: '/_tablet-layout/branch/$id/'
      path: '/'
      fullPath: '/branch/$id/'
      preLoaderRoute: typeof TabletLayoutBranchIdIndexRouteImport
      parentRoute: typeof TabletLayoutBranchIdRoute
    }
    '/_tablet-layout/branch/$id/create/_wizard': {
      id: '/_tablet-layout/branch/$id/create/_wizard'
      path: '/create'
      fullPath: '/branch/$id/create'
      preLoaderRoute: typeof TabletLayoutBranchIdCreateWizardRouteImport
      parentRoute: typeof TabletLayoutBranchIdRoute
    }
    '/_tablet-layout/branch/$id/create/_wizard/success': {
      id: '/_tablet-layout/branch/$id/create/_wizard/success'
      path: '/success'
      fullPath: '/branch/$id/create/success'
      preLoaderRoute: typeof TabletLayoutBranchIdCreateWizardSuccessRouteImport
      parentRoute: typeof TabletLayoutBranchIdCreateWizardRoute
    }
    '/_tablet-layout/branch/$id/create/_wizard/submit': {
      id: '/_tablet-layout/branch/$id/create/_wizard/submit'
      path: '/submit'
      fullPath: '/branch/$id/create/submit'
      preLoaderRoute: typeof TabletLayoutBranchIdCreateWizardSubmitRouteImport
      parentRoute: typeof TabletLayoutBranchIdCreateWizardRoute
    }
    '/_tablet-layout/branch/$id/create/_wizard/service': {
      id: '/_tablet-layout/branch/$id/create/_wizard/service'
      path: '/service'
      fullPath: '/branch/$id/create/service'
      preLoaderRoute: typeof TabletLayoutBranchIdCreateWizardServiceRouteImport
      parentRoute: typeof TabletLayoutBranchIdCreateWizardRoute
    }
    '/_tablet-layout/branch/$id/create/_wizard/mode': {
      id: '/_tablet-layout/branch/$id/create/_wizard/mode'
      path: '/mode'
      fullPath: '/branch/$id/create/mode'
      preLoaderRoute: typeof TabletLayoutBranchIdCreateWizardModeRouteImport
      parentRoute: typeof TabletLayoutBranchIdCreateWizardRoute
    }
    '/_tablet-layout/branch/$id/create/_wizard/master/': {
      id: '/_tablet-layout/branch/$id/create/_wizard/master/'
      path: '/master'
      fullPath: '/branch/$id/create/master/'
      preLoaderRoute: typeof TabletLayoutBranchIdCreateWizardMasterIndexRouteImport
      parentRoute: typeof TabletLayoutBranchIdCreateWizardRoute
    }
    '/_tablet-layout/branch/$id/create/_wizard/master/pair': {
      id: '/_tablet-layout/branch/$id/create/_wizard/master/pair'
      path: '/master/pair'
      fullPath: '/branch/$id/create/master/pair'
      preLoaderRoute: typeof TabletLayoutBranchIdCreateWizardMasterPairRouteImport
      parentRoute: typeof TabletLayoutBranchIdCreateWizardRoute
    }
  }
}

interface TabletLayoutBranchIdCreateWizardRouteChildren {
  TabletLayoutBranchIdCreateWizardModeRoute: typeof TabletLayoutBranchIdCreateWizardModeRoute
  TabletLayoutBranchIdCreateWizardServiceRoute: typeof TabletLayoutBranchIdCreateWizardServiceRoute
  TabletLayoutBranchIdCreateWizardSubmitRoute: typeof TabletLayoutBranchIdCreateWizardSubmitRoute
  TabletLayoutBranchIdCreateWizardSuccessRoute: typeof TabletLayoutBranchIdCreateWizardSuccessRoute
  TabletLayoutBranchIdCreateWizardMasterPairRoute: typeof TabletLayoutBranchIdCreateWizardMasterPairRoute
  TabletLayoutBranchIdCreateWizardMasterIndexRoute: typeof TabletLayoutBranchIdCreateWizardMasterIndexRoute
}

const TabletLayoutBranchIdCreateWizardRouteChildren: TabletLayoutBranchIdCreateWizardRouteChildren =
  {
    TabletLayoutBranchIdCreateWizardModeRoute:
      TabletLayoutBranchIdCreateWizardModeRoute,
    TabletLayoutBranchIdCreateWizardServiceRoute:
      TabletLayoutBranchIdCreateWizardServiceRoute,
    TabletLayoutBranchIdCreateWizardSubmitRoute:
      TabletLayoutBranchIdCreateWizardSubmitRoute,
    TabletLayoutBranchIdCreateWizardSuccessRoute:
      TabletLayoutBranchIdCreateWizardSuccessRoute,
    TabletLayoutBranchIdCreateWizardMasterPairRoute:
      TabletLayoutBranchIdCreateWizardMasterPairRoute,
    TabletLayoutBranchIdCreateWizardMasterIndexRoute:
      TabletLayoutBranchIdCreateWizardMasterIndexRoute,
  }

const TabletLayoutBranchIdCreateWizardRouteWithChildren =
  TabletLayoutBranchIdCreateWizardRoute._addFileChildren(
    TabletLayoutBranchIdCreateWizardRouteChildren,
  )

interface TabletLayoutBranchIdRouteChildren {
  TabletLayoutBranchIdIndexRoute: typeof TabletLayoutBranchIdIndexRoute
  TabletLayoutBranchIdCreateWizardRoute: typeof TabletLayoutBranchIdCreateWizardRouteWithChildren
}

const TabletLayoutBranchIdRouteChildren: TabletLayoutBranchIdRouteChildren = {
  TabletLayoutBranchIdIndexRoute: TabletLayoutBranchIdIndexRoute,
  TabletLayoutBranchIdCreateWizardRoute:
    TabletLayoutBranchIdCreateWizardRouteWithChildren,
}

const TabletLayoutBranchIdRouteWithChildren =
  TabletLayoutBranchIdRoute._addFileChildren(TabletLayoutBranchIdRouteChildren)

interface TabletLayoutRouteChildren {
  TabletLayoutIndexRoute: typeof TabletLayoutIndexRoute
  TabletLayoutBranchIdRoute: typeof TabletLayoutBranchIdRouteWithChildren
}

const TabletLayoutRouteChildren: TabletLayoutRouteChildren = {
  TabletLayoutIndexRoute: TabletLayoutIndexRoute,
  TabletLayoutBranchIdRoute: TabletLayoutBranchIdRouteWithChildren,
}

const TabletLayoutRouteWithChildren = TabletLayoutRoute._addFileChildren(
  TabletLayoutRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  TabletLayoutRoute: TabletLayoutRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
